<template>
    <div class="article-detail">
        <div class="banner">
            <div class="title">最新文章</div>
        </div>

        <div class="article-detail-wrap container">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'article'}">
                    <label class="clickable">最新文章</label>
                </router-link>
                <img src="@/assets/img/landingPage/arrow_right.svg"/>
                <label>文章詳情</label>
            </div>
            <div class="title">
                <div>{{article.title}}</div>
            </div>
            <div class="tags-list">
                <div class="tag" v-for="(tag, index) in article.tags" :key="index">{{tag}}</div>
            </div>
            <div class="cover" v-bind:style="{backgroundImage:'url(' + article.cover + ')'}"></div>
            <div class="content">
                <div class="paragraph" v-for="(paragraph, index) in article.content" :key="index">{{paragraph}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        this.$analytics.logEvent("文章內頁", {
            screen_name: "文章內頁"
        });
    },
    components: {

    },
    data () {
        return {
            article: {
                cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_6.jpeg',
                title: '租房可以換鎖嗎？是否該給房東一份備用鑰匙',
                tags: ['租房', '換鎖', '鑰匙', '房東', '租客'],
                content: [
                    '近期透過友人分享實際發生的案例，一天半夜隔壁房的洗衣機水管突然爆裂，陽台開始積水，水也不停從陽台往下流，像是瀑布一樣的聲響引起整條巷子的人查看，偏偏隔壁房客又出遠門，友人眼看水也開始往自己的陽台流過來，只差一公分的高度就會流進房間，只好大半夜趕緊打給房屋代管人求救，房屋代管人一到，只能無奈身上也沒有鑰匙，半夜的屋主媽媽也沒接電話，但在下去也不行，若水一直流下去，明天整棟公寓大家都沒水用，於是代管人只能硬著頭皮去附近屋主媽媽家敲門拿備用鑰匙，才解決了這個半夜驚魂。',
                    '這個案例好險屋主媽媽有一副備用鑰匙，若今天屋主媽媽沒留備份鑰匙或者隔壁租客換過鎖頭，水是不是就要一直流下去，但備用鑰匙的爭議一直存在在房東與租客之間，通常大家在閱讀租屋守則時，多數達人也都建議租客要換鎖比較安全，以法律觀點來說，房東沒有權利拒絕租客換鎖，但房東到底要可不可以要求留一份備用鑰匙。',
                    '其實租客們還是要釐清換鎖的用意，通常是防範兩件事情：一、擔心惡房東擅自進入屋內；二、擔心前租客留有備用鑰匙，第一點根據法律規定，在租賃契約有效期間，房東是無權使用房屋，亦不可任意進出租屋處，因此房東只要未經同意擅自進入屋內，房東都需負法律責任，透過法律的保護，我們可以判斷較大的潛在危險會是第二點前房客留有備用鑰匙，基本上房東也不會拒絕租客換鎖，但若是房東主動要求提供備份鑰匙，建議租客們還是要提高警覺心，問清楚房東留有備用鑰匙的用意。',
                    '回到一開始的分享，若今天都沒有人有備用鑰匙，後果也不堪設想，因此換鎖後留不留備用鑰匙給房東決定權還是在於房客本身，法律有提供租客最基本保障，嚴禁房東擅自進屋，最後提醒各位租客們，換鎖後記得要把舊的鎖頭留下，因未來退租時，房客有恢復租屋處原狀的責任，如此能避免其他的糾紛。'
                ]
            }
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .article-detail {
        margin-bottom: 40px;
        .banner {
            display: none;
        }
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
        .article-detail-wrap {
            .breadcrumbs {
                margin-top: 40px;
                label.clickable {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #b1b0b0;
                    cursor: pointer;
                }
                label.clickable:hover {
                    color: #7d7979;
                }
                label{
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #474342;
                    cursor: unset;
                }
                img {
                    margin-left: 12px;
                    margin-right: 12px;
                }
            }
            .title {
                margin-top: 34px;
                margin-bottom: 28px;
                div {
                    font-size: 26px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                }
            }
            .tags-list {
                margin-bottom: 20px;
                .tag {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #838282;
                    padding: 6px 14px;
                    border-radius: 5px;
                    background-color: #f1f3f6;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .cover {
                height: 400px;
                width: auto;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }
            .content {
                margin-top: 40px;
                .paragraph {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                    margin-bottom: 32px;
                }
            }
        }
    }
    @media screen and (max-width: 1100px){
        .article-detail {
            .banner {
                display: block;
                position: relative;
                margin-bottom: 14px;
                height: 198px;
                width: 100%;
                background-image: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                .title {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 24px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ffffff;
                }
            }
            .container {
                width: unset;
                padding: 0 20px;
            }
            .article-detail-wrap {
                .breadcrumbs {
                    display: none;
                }
                .cover {
                    height: 207px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/officailPage/article/articleDetail_6.vue